import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {
    Table,
    SearchButton,
    LightTextButton,
    FilterDropdown,
    SwitchButton,
    ImageStamp,
    TextLink,
    TextInput,
    Status,
    Search
} from "components";
import {customersAction, memberProfileAction} from "redux/actions";
import PackagesPopup from "../popups/Packages/PackagesPopup";
import {useHistory, useLocation} from "react-router-dom";
import * as XLSX from "xlsx";
import {Modal} from "@material-ui/core";
import ReportModal from "../../Report/ReportModal";
import MemberProfileDetailsModal from "../../Report/MemberProfileDetailsModal";
import {adminToken} from "../../../helper";
import axios from "axios";
import {AWS_URL_UM_INT_8089} from "../../../configurations";
import {elderAllSubAction} from "redux/actions";
// import MemberProfileDetailsModal from "../modals/MemberProfileDetailsModal";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";

const initialState = {
    id: "",
    elder_id: "",
    first_name: "",
    mobile: ""
};

export default function Subscription24X7Panel() {
    // Routers
    const {push, location} = useHistory();

    const [openModal, setOpenModal] = useState(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [openCusModal, setOpenCusModal] = useState(false)

    const handleOpenCusModal = () => {
        setOpenCusModal(true)
    }

    const handleCloseCusModal = () => {
        setOpenCusModal(false)
    }

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    const [clickedCustomer, setClickedCustomer] = useState(null)
    const [clickedElder, setClickedElder] = useState(null)
    const [clickedSubscription, setClickedSubscription] = useState(null)

    // Query based filter
    const locationSearch = useLocation().search;
    const query = new URLSearchParams(locationSearch);
    const userID = 1;//query.get("userID");

    // States
    const [tableRows, setTableRows] = useState();
    const [exportdata, setExportdata] = useState();
    const [editableDetail, setEditableDetails] = useState();
    const [isPopupVisible, setPopupVisible] = useState();

    // const [filterState, setFilterState] = useState(false)

    // Filter States
    const [status, setStatus] = useState();
    const [filterState, setfilterState] = useState(initialState);

    // Redux actions
    const dispatch = useDispatch();
    const {datas, userRole} = useSelector(state => ({
        datas: state.elderAllSub,
            userRole: state.userRole?.filter(role => role.module === "24x7 Subscription")
    }));
    //const datas = useSelector(state => state.elderAllSub);

    const onChange = e => setfilterState({...filterState, [e.target.name]: e.target.value});

    // internal search
    const internalSearch = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;

        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item[searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    // internal search for user details sub arrsy
    const internalSearchUser = (searchBy, rows) => {
        if (!filterState?.[searchBy]) return rows;
        const filteredRows =
            rows?.length &&
            rows.filter(
                item =>
                    item['get_user'][searchBy]
                        ?.toString()
                        .toLowerCase()
                        .indexOf(filterState?.[searchBy]?.toLowerCase()) !== -1
            );

        return filteredRows;
    };

    useEffect(() => {
        console.log(clickedElder);
        dispatch(elderAllSubAction.get());
        return () => dispatch(elderAllSubAction.reset());
    }, []);

    const onPageChange = e => dispatch(customersAction.get(e));

    useEffect(() => {
        let filtered = datas;
        if (!filtered?.length) {
            setTableRows();
            return;
        }

        if (userRole?.find(item => item.privilege === "Read")){
            filtered = internalSearch("id", filtered);
            filtered = internalSearch("elder_id", filtered);
            filtered = internalSearchUser("first_name", filtered);
            filtered = internalSearchUser("mobile", filtered);
        }

        setExportdata(filtered);

        let newData = [];
        // const printContryName = (contrycode) => {
        //     return (contrycode == '+91')?'India':contrycode;
        // }
        // Map table rows
        filtered?.forEach(obj => {
            const data = {
                id: obj?.id,
                elder_id: (
                    <TextLink
                        text={obj?.elder_id}
                        onClick={() => {
                            // push(`${location.pathname}/${obj?.userId}`)
                            setClickedElder({id: obj?.elder_id, user_id: obj?.get_user?.id, mobile: obj?.get_user?.mobile, dob:obj?.get_user?.dob, name: obj?.get_user?.first_name + " " + obj?.get_user?.last_name})
                            handleOpenModal()
                        }}
                    />
                ),
                elder_name: obj?.get_user?.first_name + " " + obj?.get_user?.last_name,
                elder_mobile: obj?.get_user?.mobile,
                package_name: obj?.subscription_package_name,
                // caregiver_name: obj?.primary_caregiver_name,
                // caregiver_relationship_name: obj?.caregiver_relationship_name,
                number_of_bedrooms: obj?.number_of_bedrooms,
                plan_activated_at: `${new Date(obj?.plan_activated_at).toLocaleString()}`,
                plan_expiry_at: (
                    <div
                    dangerouslySetInnerHTML={{
                        __html: (new Date(obj?.plan_expiry_at) < new Date())
                        ? `<span style="color:red;">${new Date(obj?.plan_expiry_at).toISOString().split("T")[0]}</span>`
                        : new Date(obj?.plan_expiry_at).toISOString().split("T")[0]
                    }}
                    />
                ),
                plan_renewal_at: (
                    <div
                    dangerouslySetInnerHTML={{
                        __html: (new Date(obj?.plan_renewal_at) < new Date())
                        ? `<span style="color:red;">${new Date(obj?.plan_renewal_at).toISOString().split("T")[0]}</span>`
                        : new Date(obj?.plan_renewal_at).toISOString().split("T")[0]
                    }}
                    />
                ),
                monitoring_enabled: obj?.monitoring_enabled,
                createdAt: `${new Date(obj?.created_at).toLocaleString()}`,
                updatedAt: `${new Date(obj?.updated_at).toLocaleString()}`
            };
            newData.push(data);
        });

        setTableRows(newData);
    }, [datas, status, filterState]);

    // Search based on category & sub category name
    const onSearch = () => {
    };

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Subscription"
            },
            {
                title: "Elder"
            },
            {
                title: "Elder Name"
            },
            {
                title: "Elder Mobile"
            },
            {
                title: "Package Name"
            },
            // {
            //     title: "Caregiver Name"
            // },
            // {
            //     title: "Caregiver Relationship"
            // },
            {
                title: "Bedrooms"
            },
            {
                title: "Plan Activated"
            },
            {
                title: "Plan Expiry"
            },
            {
                title: "Plan Renewal"
            },
            {
                title: "Monitoring Enabled"
            },
            {
                title: "Created"
            },
            {
                title: "Updated"
            }
        ],
        [tableRows]
    );
    //v2-app
    const exportDataFunc = () => {
        const rows = exportdata.map(item => {
            return {
                "Subscription": item.id,
                "Elder": item.elder_id,
                "Elder Name": item?.get_user?.first_name + " " + item?.get_user?.last_name,
                "Elder Mobile": item?.get_user?.mobile,
                "Package Name": item?.subscription_package_name,
                "Bedrooms": item?.number_of_bedrooms,
                "Plan Activated": item?.plan_activated_at,
                "Plan Expiry": item?.plan_expiry_at,
                "Plan Renewal": item.plan_renewal_at,
                "Created At": item.created_at,
                "Updated At": item.updated_at,
                "Monitoring Enabled": item.monitoring_enabled,
            }
        })

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, "Subscription24X7Data.xlsx");
    }

    return (
        <div>
            <div className={styles.filter}>
                <TextInput
                    label="Subscription"
                    name="id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.id}
                />

                <TextInput
                    label="Elder"
                    name="elder_id"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.elder_id}
                />

                <TextInput
                    label="Elder Name"
                    name="first_name"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.first_name}
                />

                <TextInput
                    label="Elder Mobile"
                    name="mobile"
                    type="text"
                    onChange={userRole?.find(item => item.privilege === "Read") ? onChange : null}
                    style={{width: 150}}
                    value={filterState?.mobile}
                />

                <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                        onClick={exportDataFunc}
                >Export Data
                </button>

                {/*<LightTextButton onClick={() => setfilterState(initialState)}/>*/}
            </div>
            
            {/* totalPage: Math.ceil(customers?.count / 10) */}

            <Table
                headers={tableHeaders}
                data={tableRows}
                current={datas?.pageNumber}
                totalPage={Math.ceil(datas?.count / 10)}
                onPageChange={''}
                state={filterState !== initialState}
                length={tableRows?.length}
                r_length={datas?.users?.length}
                t_length={datas?.count}
                exportData={false}
                // exportDataFunc={exportDataFunc}
            />

            {isPopupVisible && (
                <PackagesPopup
                    data={editableDetail}
                    closeModal={() => setPopupVisible(false)}
                />
            )}

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <MemberProfileDetailsModal clickedElder={clickedElder} handleCloseModal={handleCloseModal}
                             setClickedSubscription={setClickedSubscription}
                             handleOpenSubscriptionModal={handleOpenSubscriptionModal}/>
            </Modal>

            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <MemberProfileDetailsModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>
        </div>
    );
}
